import React from "react";
import styles from "../../pages/OnBoarding/UserOnboarding.module.css";
import pass from "./LoginForm.module.css"   
import SlideUpWrapper from "../Transitions/SlideUpWrapper";
import RightContent1 from "./login_right";
import { useNavigate } from "react-router-dom";
import { BUTTONS } from "../../Utils/Strings";
const VerifyPassword=()=>{
    const navigate=useNavigate();
    const handleVerify=()=>{
        localStorage.clear()
        navigate('/login')
    }

    return(
        <SlideUpWrapper direction="slide-left">
        <div className={styles.userOnboarding}>
            <form className={pass.leftContent} onSubmit={handleVerify}>
                <div className={styles.progressForm}>
                    <div className={styles.progressForm1}>
                        <div className={pass.form}>                            
                            <div className={styles.form1}>
                                <img src="/checkcircle.svg" alt="checkcircle.svg" className={pass.verifypass}/>
                                <div className={styles.headingHelperText}>
                                    <h3 className={pass.Resetheading}>Password reset!</h3>
                                    <div className={pass.supportingText}>
                                        <p className={styles.weMessagedASixDigitCodeT}>
                                        <span className={pass.weMessagedA}>Your Password has been successfully reset.</span><br/>
                                        <span className={pass.weMessagedA}>  Click below to login.</span>                              
                                        </p>
                                        <div className={pass.inputdiv}>  
                                            <button type="submit" className={pass.forgotBtn} style={{width:"85%"}}>{BUTTONS.CONTINUE}</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={pass.copyright}>
                Copyright 2026 AuthBridge, All Rights Reserved.
            </div>
            </form>
      <RightContent1 />
        </div>
        </SlideUpWrapper>
    )

}
export default VerifyPassword;